import script from "./VisitTimeSlotGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitTimeSlotGroup.vue?vue&type=script&setup=true&lang=js"

import "./VisitTimeSlotGroup.vue?vue&type=style&index=0&id=465efdfa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465efdfa"]])

export default __exports__